import { render, staticRenderFns } from "./ConfirmComponent.vue?vue&type=template&id=c93c9c48&scoped=true&"
import script from "./ConfirmComponent.vue?vue&type=script&lang=js&"
export * from "./ConfirmComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93c9c48",
  null
  
)

export default component.exports